/** Persisted estimated AI request count; resets when the calendar date changes (local). */

const LS_KEY = "idwiz.aiDailyRequests.v1";

export function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

export function getDailyAiRequestState() {
  const date = todayKey();
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { date, count: 0 };
    const o = JSON.parse(raw);
    if (o.date !== date) return { date, count: 0 };
    return { date, count: Math.max(0, Number(o.count) || 0) };
  } catch {
    return { date, count: 0 };
  }
}

/** @returns {number} new count after increment */
export function incrementDailyAiRequests() {
  const s = getDailyAiRequestState();
  const next = { date: s.date, count: s.count + 1 };
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent("idwiz-ai-attempt"));
  return next.count;
}
